const NotFound = ({ message, title }) => (
  <div className="ma-not-found has-background-info has-text-white">
    <div className="not-found-icon-wrapper">
      <span className="icon">
        <i className="mdi mdi-36px mdi-alert-circle" />
      </span>
    </div>
    <div className="not-found-content-wrapper">
      {title && <div className='not-found-title'>{title}</div>}
      <div className='not-found-message'>{message}</div>
    </div>
  </div>
)

NotFound.defaultProps = {
  message: 'Not Found'
}

export default NotFound



// WEBPACK FOOTER //
// ./components/uiLib/NotFound/index.js